export default {
  status: {
    open: "Aperto",
    in_progress: "In corso",
    waiting_response: "In attesa di risposta",
    resolved: "Risolto",
    closed: "Chiuso",
  },
  priority: {
    "1": "Critica",
    "2": "Alta",
    "3": "Media",
    "4": "Bassa",
    "5": "Triviale",
  },
  category: {
    problem: "Problema",
    suggestion: "Suggerimento",
    improvement: "Miglioramento",
    question: "Domanda",
    billing: "Fatturazione",
  },
} as const;
